import { render, staticRenderFns } from "./sprint-answer-background.vue?vue&type=template&id=94b679ca&scoped=true&"
import script from "./sprint-answer-background.vue?vue&type=script&lang=js&"
export * from "./sprint-answer-background.vue?vue&type=script&lang=js&"
import style0 from "./sprint-answer-background.vue?vue&type=style&index=0&id=94b679ca&scoped=true&lang=scss&"
import style1 from "./sprint-answer-background.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b679ca",
  null
  
)

export default component.exports